import React from "react";
import { useTranslation } from "react-i18next";

import Loader from "../../../../../../../../components/Loader";
import {
	StyledSpan,
	StyledColumn,
} from "../../../../../../../../components/common";

import Chart from "./Chart";

const Content: React.FC<Content.Props> = ({
	loading,
	localizedChartData,
	chartType,
	colors,
}) => {
	const { t } = useTranslation();

	return (
		<StyledColumn
			justify="center"
			alignItems="center"
			h="100%"
			w="100%"
			style={{
				paddingBlock: "8px",
				paddingInline: "10px",
				overflow: "hidden",
				position: "relative",
			}}
		>
			<Loader active={loading} dimmed={false} lightDimmed withText>
				{localizedChartData &&
				(localizedChartData?.sets?.length ?? 0) > 0 ? (
					<Chart
						data={localizedChartData}
						type={chartType}
						colors={colors}
					/>
				) : (
					<StyledSpan
						justify="center"
						alignItems="center"
						h="100%"
						w="100%"
					>
						{t("mainPage.reports.charts.noChart")}
					</StyledSpan>
				)}
			</Loader>
		</StyledColumn>
	);
};

declare namespace Content {
	interface Props {
		loading: boolean;
		localizedChartData: Chart.OrderChartData | null;
		chartType: Chart.ChartType;
		colors: string[];
	}
}

export default Content;
